import {
  TruckerGetResponseInterface,
  TruckerInterface,
} from '@interface/trucker';
import { SuggestionInterface } from '@components/ui/AutoComplete';
import apiService from './config';

const transformData = (
  data: TruckerInterface[],
): SuggestionInterface<TruckerInterface>[] =>
  data.map((item) => ({
    ...item,
    id: item.id,
    description: item.name,
  }));

export const getTrucker = (
  cpf: string,
): Promise<TruckerGetResponseInterface['data']> => {
  const params = {
    cpf,
  };

  return apiService
    .get<TruckerGetResponseInterface['data']>(`truckers/`, {
      params,
    })
    .then((response) => transformData(response.data));
};
